import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const ShareSpaceModal = () => {
  const url = window.location.href; // Current URL of the page
  const emailSubject = "Check out this space!";
  const emailBody = `I wanted to share this amazing space with you: ${url}`;
  const { t } = useTranslation("global");
  const [isCopied, setIsCopied] = useState(false);

  const handleEmailShare = () => {
    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink; // Opens the default email client
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(url);
    setIsCopied(true); // Update state to indicate the link has been copied
    setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
  };

  return (
    <div className={styles.shareSpaceModal}>
      <div className={styles.linkContainer}>
        <input
          type="text"
          className={styles.linkInput}
          value={url}
          readOnly
        //   onClick={(e) => e.target.select()} // Allows easy text selection
        onClick={handleCopyToClipboard}
        />
        <button className={styles.copyButton} onClick={handleCopyToClipboard}>
          {!isCopied ? t("modal.share.copy") : t("modal.share.copied")}
        </button>
      </div>

      <div className={styles.actions}>
        <button
          className={`${styles.button} ${styles.emailButton}`}
          onClick={handleEmailShare}
        >
          {t("modal.share-email")}{" "}
        </button>
        <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
            `Check out this space: ${url}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.button} ${styles.whatsappButton}`}
        >
          {t("modal.share-whatsapp")}{" "}
        </a>
      </div>
    </div>
  );
};

export default ShareSpaceModal;
